import { IntilioCodes } from '@shared/enums/initilio-codes.enum';

/**
 * The API answers with `{ error: { message: 'Item no exists', messageCode: 'intilio_1' } }` for a removed entry.
 * Depending on the status code the error reaches the subscriber unwrapped (BaseHttpService) or as the HttpErrorResponse.
 */
export function isItemNotFoundError(error: any): boolean {
  const messageCode = error?.messageCode ?? error?.error?.messageCode ?? error?.error?.error?.messageCode;

  return messageCode === IntilioCodes.ITEM_NOT_EXISTS || error?.status === 404;
}
